import { useLocation } from "react-router-dom";
import { ClientStorage, ClientStorageItem } from "../utils/clientstorage";
import { UserWeddingRole } from "../types/wedding";

export const useEventPlannerPath = () => {
  const location = useLocation();

  const userWeddingRole = ClientStorage.fetch(
    ClientStorageItem.UserWeddingRole
  ) as UserWeddingRole;

  const plannerWeddingMatch = location.pathname.match(/^\/planner\/weddings\/([^/]+)/);
  const legacyWeddingMatch = location.pathname.match(/^\/wdn\/([^/]+)/);
  const weddingMatch = plannerWeddingMatch || legacyWeddingMatch;
  const isEventPlannerPath = Boolean(weddingMatch);
  const isEventPlanner =
    userWeddingRole === UserWeddingRole.EventPlanner && isEventPlannerPath;

  const basePath = isEventPlanner && weddingMatch
    ? `/planner/weddings/${weddingMatch[1]}`
    : "";

  const weddingID = weddingMatch?.[1] || "";

  return {
    isEventPlanner,
    isEventPlannerPath,
    basePath,
    weddingID,
    userWeddingRole,
  };
};
